import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Form, Input,InputNumber,Select,Typography,Popconfirm,Switch,Checkbox,Radio,TimePicker,AutoComplete,DatePicker,ColorPicker,Button} from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import MyTable from 'components/table/table';
import {useParentState} from 'utils';
import {getFormItem} from './form';

import Language from 'components/language';

const getRenderItem=()=>{
  
}

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  schema,
  parentData,
  children,
  form,
  ...restProps
}) => {  
  
  return (
    <td {...restProps}>
      {editing ? getFormItem({form,schema,parentData,key:dataIndex,hideLabel:true}):
      schema?.properties?.[dataIndex]?.getValue?schema?.properties?.[dataIndex]?.getValue(parentData,record[dataIndex]):children
            
      }
    </td>
  );
};


export default ({
  rowKey="id",
  columns,
  data:_data,
  setData:_setData,
  onEdit,  
  ...other
  }) => {
    
    
    
  const [form] = Form.useForm();
  const [data, setData] = useParentState(_data,_setData);
  const [editingKey, setEditingKey] = useState('');
  
  const isEditing = (record) => record[rowKey] === editingKey;
  
  const edit = (record) => {
    
    form.setFieldsValue({...record});
    setEditingKey(record[rowKey]);
  };  
  const cancel = () => {
    setEditingKey('');
  };
  
  const handleDelete = (record) => {
    const newData = [...data];
    const index = newData.findIndex((item) => record?.[rowKey] === item?.[rowKey]);      
    newData.splice(index, 1,);    
    setData(newData);
  };
  
  const save = async (key) => {
    
    try {
      const row = await form.validateFields();
      
      const newData = [...data];
      const index = newData.findIndex((item) => key === item[rowKey]);
      if (index > -1) {
        
        const item = newData[index];
        
        newData.splice(index, 1, {
          ...item,
          ...row,
        });        
        
        setData(newData);
        setEditingKey('');
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey('');
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };
  
  const newColumns = [
    ...columns||[],
    {
      title: '',
      dataIndex: 'operation',
      width:100,
      key: 'operation',
      visible:true,
      render: (_, record) => {
        
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record[rowKey])}
              style={{
                marginRight: 8,
              }}
            >
              <Language id="OK"/>
            </Typography.Link>
            <Popconfirm okText=<Language id="Yes"/> cancelText=<Language id="No"/> title={<Language id="CancelMessage"/>} onConfirm={cancel}>
              <a><Language id="Cancel"/></a>
            </Popconfirm>
          </span>
        ) : (
          <Button disabled={record?.name=="Average/Moyen" || editingKey !== ''} type="link" style={{    wordBreak: "initial"}} onClick={onEdit?()=>onEdit(record):() => edit(record)}>
            <Language id="edit" />
          </Button>
        );
      },
    },
   {
    title: '',
    key: 'action',
    visible:true,
    width:50,
    render: (_, record) => (
               <Popconfirm
            title=<Language id={"DeleteMessage"}/>
            onConfirm={() => handleDelete(record)}
            okText=<Language id="Yes"/> cancelText=<Language id="No"/>
            
            
          >
            <Button
              type="link"
              shape="circle"
              disabled={record?.name=="Average/Moyen"}
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
    ),
  }
  ];
  
  const mergedColumns = newColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        schema:col.schema,
        form,  
        parentData:col.parentData,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  
  const {schema}=mergedColumns[0];
  const onValuesChange = schema?.onValuesChange;
  return (
    <Form 
      form={form} 
      component={false}
      onValuesChange={(value,values)=>onValuesChange&&onValuesChange(form,value,values)}
      >
      <MyTable
        rowKey={rowKey}
        tableComponents = {{body: {cell: EditableCell } }}
        data={data}
        columns={mergedColumns}
        {...other}
      />
    </Form>
  );
};